import React from 'react'
import Affirmations from '../data/Affirmations'

const AnnouncementContext = React.createContext(null)

export function AnnouncementProvider({ children }) {
    const [queue, setQueue] = React.useState([])

    const announce = React.useCallback((message) => {
        setQueue(prev => [...prev, { message, type: 'result' }])
    }, [])

    const announceAffirmation = React.useCallback(() => {
        const affirmation = Affirmations[Math.floor(Math.random() * Affirmations.length)].message
        setQueue(prev => [...prev, { message: affirmation, type: 'affirmation' }])
    }, [])

    const dismiss = React.useCallback(() => {
        setQueue(prev => prev.slice(1))
    }, [])

    const announcement = queue[0] ?? null

    return (
        <AnnouncementContext.Provider value={{ announce, announceAffirmation, dismiss, announcement }}>
            {children}
            {announcement && (
                <div
                    className="fixed inset-0 z-[500] flex items-center justify-center bg-black/70"
                >
                    <div
                        className="relative mx-4 max-w-sm w-full rounded-2xl bg-bankroll-navy border-2 border-bankroll-primary shadow-2xl px-8 py-10 flex flex-col items-center gap-5 text-center"
                    >
                        {announcement.type === 'result' ? (
                            <>
                                <div className="text-5xl animate-bounce select-none">🏆</div>
                                <h2 className="text-2xl font-bold text-bankroll-primary m-0 leading-tight">
                                    Game Over!
                                </h2>
                                <p className="text-gray-100 text-base font-karla font-semibold m-0 leading-snug">
                                    {announcement.message}
                                </p>
                            </>
                        ) : (
                            <p className="text-gray-100 text-base font-karla italic m-0 leading-snug">
                                {announcement.message}
                            </p>
                        )}
                        <button
                            onClick={dismiss}
                            className="mt-2 px-6 py-2.5 bg-bankroll-primary text-white border-0 rounded-lg font-karla font-bold text-sm cursor-pointer hover:opacity-90"
                        >
                            Dismiss
                        </button>
                    </div>
                </div>
            )}
        </AnnouncementContext.Provider>
    )
}

export function useAnnouncement() {
    return React.useContext(AnnouncementContext)
}
